// extracted by mini-css-extract-plugin
module.exports = {"IconWrapper":"info-state_IconWrapper__FKeAc","pulse":"info-state_pulse__pAhTe","Image":"info-state_Image__z90vu"};